export const roundPrice = (price: { cents: number }) => {
  const priceInCents = price.cents // 30010500
  const priceInEuro = priceInCents / 100 // 300105

  const remainder = priceInEuro % 1000 // 105 if priceInEuro = 300105
  const roundedPriceInEuro = remainder < 500 ? priceInEuro - remainder : priceInEuro + (1000 - remainder) // 300000

  const roundedPriceInCents = roundedPriceInEuro * 100 // 30000000

  return { ...price, cents: roundedPriceInCents }
}

export const getPriceStatus = (askedPriceCents: number, estimatedListingPriceCents: number) => {
  const discountedPrice = ((askedPriceCents - estimatedListingPriceCents) / askedPriceCents) * 100
  const roundedDiscountedPrice = Math.round(discountedPrice)
  const isGoodPrice = roundedDiscountedPrice < 8

  return { isGoodPrice, roundedDiscountedPrice }
}
